import { render, staticRenderFns } from "./MemberFilterCuratorLayout.vue?vue&type=template&id=4db484be&"
import script from "./MemberFilterCuratorLayout.vue?vue&type=script&lang=js&"
export * from "./MemberFilterCuratorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports